import axios from 'axios';
import { setAxiosInterceptors } from '@lendica/auth';
import { matchBackend } from '@lendica/utils';

export const env = process.env.REACT_APP_ENV || 'idev';
// export const env = 'prod';

// export const baseURL =
//     env === 'prod' ? 'https://api.golendica.com/api/v1' : 'https://api-dev.golendica.com/api/v1';

export const baseURL = matchBackend();

export const axiosInstance = axios.create({ baseURL });
axios.defaults.baseURL = baseURL;
setAxiosInterceptors(baseURL);

declare global {
    interface Window {
        lendicaConfig: any;
    }
}

window.lendicaConfig = {
    env,
};
